function minimum(a, b, c) {
  let result = a
  if (b < result) result = b
  if (c < result) result = c
  return result
}

function levenshteinDistance(s, t) {
  s = `_${s}`
  t = `_${t}`
  const sLength = s.length
  const tLength = t.length
  const d = []
  for (let i = 0; i <= sLength; i += 1) {
    d.push([])
    for (let j = 0; j <= tLength; j += 1) {
      d[i].push(0)
    }
  }

  for (let i = 1; i <= sLength; i += 1) {
    d[i][0] = i
  }

  for (let i = 1; i <= tLength; i += 1) {
    d[0][i] = i
  }

  let substitutionCost = 0
  for (let j = 1; j <= tLength; j += 1) {
    for (let i = 1; i <= sLength; i += 1) {
      if (s[i] === t[j]) {
        substitutionCost = 0
      } else {
        substitutionCost = 1
      }
      d[i][j] = minimum(
        d[i - 1][j] + 1,
        d[i][j - 1] + 1,
        d[i - 1][j - 1] + substitutionCost)
    }
  }

  return d[sLength][tLength]
}

export default function wordSimilarity(correctAnswer, userAnswer) {
  let wordsDistance = 0
  let wordSimilarity = 0
  let correctLength = 0
  if (!userAnswer) return 0

  correctLength = correctAnswer.length
  wordSimilarity = 0
  wordsDistance = levenshteinDistance(correctAnswer, userAnswer)

  if (wordsDistance / correctLength <= 0.1) {
    wordSimilarity = 0.75
  } else if (wordsDistance / correctLength <= 0.25 && wordsDistance / correctLength > 0.1) {
    wordSimilarity = 0.5
  } else if (wordsDistance / correctLength < 0.35) {
    wordSimilarity = 0.25
  }
  if (wordsDistance === 0) {
    wordSimilarity = 1
  }
  if (!wordSimilarity) return 0
  return wordSimilarity
}



// WEBPACK FOOTER //
// ./src/common/lib/wordSimilarity.js